///
/// EarthBrowser
///
/// Created by Matt Giger on 9/23/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useAppSelector } from "@/redux/store"
import { syncStories } from "@/redux/storiesSync"
import { useEffect } from "react"

/**
 * Triggers story tours delta syncs: on app start when already signed in,
 * on sign-in (anonymous local stories get pushed up), and on regained
 * connectivity. Individual mutations push live via the store listener;
 * this covers everything those pushes could have missed.
 */
export function useStoriesSync() {
	const userId = useAppSelector(state => state.user.userProfile?.id)

	useEffect(() => {
		if (userId === undefined) return

		void syncStories()

		const onOnline = () => { void syncStories() }
		window.addEventListener("online", onOnline)
		return () => window.removeEventListener("online", onOnline)
	}, [userId])
}
